import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import DashboardLayout from "../../layouts/Dashboard";
import { Button, Grid, TextField } from "@mui/material";
import useDialogs from "../../components/Dialog/useDialogs";
import useLoader from "../../hooks/useLoader";
import { renderControls } from "../../functions";
import { FormSection, PageContainer, PageFooter, PageHeader } from "../../components";
import { formatDateAsDate, formatDateAsDateTime } from "../../functions/formatters";
import { getRequestLockByKey } from "../../redux/actions/requestLockActions";
import { REQUEST_LOCK_LIST_ROUTE } from "../../routes";

export const DetailsRequestLock = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { push } = useHistory();
    const {
        loading: fetchLoading,
        start: fetchStart,
        stop: fetchStop,
    } = useLoader(true);
    const [data, setData] = useState({});

    const {alert, DIALOG} = useDialogs();

    const fetch = async () => {
        fetchStart();

        const item = await dispatch(getRequestLockByKey(id));
        if (!item) {
            alert('Нет данных (неверный ID или данная запись удалена)!');
            fetchStop();
            return;
        }

        setData(item);
        fetchStop();
    };

    useEffect(async () => {
        await fetch();
    }, [dispatch, id, fetchStart, fetchStop]);

    const controls = [
    {
        state: "current",
        buttons: [
            <Button
                variant={"text"}
                onClick={() => push(REQUEST_LOCK_LIST_ROUTE)}
            >
                Вернуться
            </Button>,
        ],
    }
    ];

    return (
        <DashboardLayout>
            <DIALOG/>
            <PageHeader heading={`ID записи ${data?.id}`} controls={renderControls(controls, {})}>
            </PageHeader>
            <PageContainer>
                <FormSection>
                    <Grid container>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            margin="normal"
                            id={"time"}
                            label={"Месяц"}
                            value={formatDateAsDate(data.time)}
                            disabled={true}
                            fullWidth
                            xs={6}
                        />
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            margin="normal"
                            id={"isLocked"}
                            label={"Заблокирован"}
                            value={data.isLocked ? "Да" : "Нет"}
                            disabled={true}
                            fullWidth
                            xs={6}
                        />
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            margin="normal"
                            id={"filial"}
                            label={"Филиал"}
                            value={data.filial}
                            disabled={true}
                            fullWidth
                            xs={6}
                        />
                    </Grid>
                </FormSection>
            </PageContainer>
            <PageFooter heading={`ID записи ${data?.id}`} controls={renderControls(controls, {})}>
            </PageFooter>
        </DashboardLayout>
    )
};
